/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, ReactElement, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import { GetAllDeviceCategory, AddNewDevice, GetDeviceByName } from "../core/_requests";
import Select from "react-select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Modal } from "react-bootstrap";
import { useModal } from "../context/DeviceModalContext";
import { KTIcon } from "../../../../_metronic/helpers";
import { useAuth } from "../../auth";
import { handleApiError, handleFullApiError } from "../../utils/apiUtils";
import { useFirstLogin } from "../../auth/core/TourGuideContext";
import type { SelectInstance } from "react-select";
import { useTranslation } from "react-i18next";

const AddDevice = ({ refreshDevicesList }) => {
  const { t } = useTranslation();

  type DeviceCategories = {
    value: string;
    label: string | ReactElement;
    icon: string;
    name: string;
  };
  const { setAddedNewDevice, hasAddedNewDevice } = useFirstLogin();
  const [deviceCategories, setDeviceCategories] = useState<DeviceCategories[]>([]);
  const [selectedDeviceCategoryOption, setselectedDeviceCategoryOption] = useState(deviceCategories[0]);
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [showWarningMessage, setShowWarningMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLinkAnalyze, setShowLinkAnalyze] = useState(false);
  const [showFileAnalyze, setShowFileAnalyze] = useState(false);
  const [nodejsFileAnalyzeForSend, setNodejsFileAnalyzeForSend] = useState(null);
  const [nodejsFileAnalyzeForReceive, setNodejsFileAnalyzeForReceive] = useState(null);
  const [jsAnalyzerFileForSMSSend, setJsAnalyzerFileForSMSSend] = useState(null);
  const [jsAnalyzerFileForSMSReceive, setJsAnalyzerFileForSMSReceive] = useState(null);
  const [imageFile, setImageFile] = useState();
  const [helpFile, setHelpFile] = useState();
  const [settingFile, setSettingFile] = useState();
  const [deviceName, setDeviceName] = useState("");
  const [isDeviceNameExist, setIsDeviceNameExist] = useState<boolean>();
  const [analyzeTypeValue, setAnalyzeTypeValue] = useState("");
  const [imageSizeError, setImageSizeError] = useState(false);
  const [htmlPageSizeError, setHtmlPageSizeError] = useState(false);
  const [settingFileSizeError, setSettingFileSizeError] = useState(false);
  const [analyzerForSendSizeError, setAnalyzerForSendSizeError] = useState(false);
  const [analyzerForReceiveSizeError, setAnalyzerForReceiveSizeError] = useState(false);
  const [analyzerForSMSSendSizeError, setAnalyzerForSMSSendSizeError] = useState(false);
  const [analyzerForSMSReceiveSizeError, setAnalyzerForSMSReceiveSizeError] = useState(false);
  const [sendSMSRequestTypeValue, setSendSMSRequestTypeValue] = useState("");
  const closeModal = useRef<HTMLButtonElement>(null);
  const formRef = useRef<HTMLFormElement>(null);
  const selectRef = useRef<SelectInstance<any, false> | null>(null);
  const MAX_IMAGE_LENGTH = process.env.REACT_APP_MAX_IMAGE_LENGTH;
  const MAX_ANALYZER_LENGTH = process.env.REACT_APP_MAX_ANALYZER_LENGTH ?? "1048576";
  const MAX_HTML_PAGE_LENGTH = process.env.REACT_APP_MAX_HTML_PAGE_LENGTH;
  const MAX_SETTING_FILE_LENGTH = process.env.REACT_APP_MAX_HTML_PAGE_LENGTH;
  const acceptableFormatForImage = process.env.REACT_APP_ACCEPTABLE_IMAGE;
  const acceptableFormatForAnalyzer = process.env.REACT_APP_ACCEPTABLE_ANALYZER;
  const acceptableFormatForHelpFile = process.env.REACT_APP_ACCEPTABLE_HELP_FILe;
  const acceptableFormatForSettingFile = process.env.REACT_APP_ACCEPTABLE_HELP_FILe;
  const {
    showAddDeviceModal,
    closeAddDeviceModal,
    userProducerCenterId,
    addDeviceSuccessfully,
    addDeviceFailed,
  } = useModal();
  const { userProducerCenter } = useAuth();
  const analyzeTypeOption = [
    { value: "10", label: t("DEVICES.ANALYZE_TYPE_OPTION.10") },
    { value: "20", label: t("DEVICES.LINK") },
  ];

  const sendSMSRequestType = [
    { value: "10", label: t("DEVICES.SMS_SEND_TYPE_STANDARD") },
    { value: "20", label: t("DEVICES.SMS_SEND_TYPE_ANALYZER") },
  ];

  const initialValues = {
    name: "",
    deviceCategoryId: "",
    producerCenterId: userProducerCenter?.producerCenterId,
    nodejsPathFileAnalyzeForSend: "",
    nodejsPathFileAnalyzeForReceive: "",
    analyzeType: "",
    tokenLink: "",
    link: "",
    image: null,
    helpFile: null,
    settingFile: null,
    sendRequestBySMSGateway: false,
    sendRequestDirectly: false,
    jsAnalyzerForSMSSend: "",
    jsAnalyzerForSMSReceive: "",
    smsAnalyzeType: "",
  };

  const changeAnalyzeTypeHandler = async (event) => {
    await formik.setFieldValue("analyzeType", event);
    formik.setFieldTouched("analyzeType", true);
    setAnalyzeTypeValue(event.value);
    if (event.value == "10") {
      setShowFileAnalyze(true);
      setShowLinkAnalyze(false);
      formik.setFieldValue("tokenLink", "");
      formik.setFieldValue("link", "");
    } else if (event.value == "20") {
      setShowFileAnalyze(false);
      setShowLinkAnalyze(true);
      setNodejsFileAnalyzeForSend(null);
      setNodejsFileAnalyzeForReceive(null);
    }
  };

  const changeSMSRequestTypeHandler = async (event) => {
    await formik.setFieldValue("smsAnalyzeType", event);
    var value = event.value;
    if (value == 10) {
      formik.setFieldValue("sendRequestDirectly", true);
      setJsAnalyzerFileForSMSSend(null);
      setJsAnalyzerFileForSMSReceive(null);
    } else if (value == 20) {
      formik.setFieldValue("sendRequestDirectly", false);
    }
    setSendSMSRequestTypeValue(value);
  };

  const showSwal = () => {
    withReactContent(Swal)
      .fire({
        title: <i>{t("COMMON.SUCCESS_OPERATION")}</i>,
        icon: "success",
        showConfirmButton: true,
        confirmButtonText: t("AUTH.REGISTER_LOGIN.OK"),
        allowOutsideClick: false,
        backdrop: true,
        allowEscapeKey: false,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          await refreshDevicesList();
          if (hasAddedNewDevice == 0) {
            setAddedNewDevice(1);
          }
        }
      });
  };

  const handleUploadNodejsAnalyzeForSend = async (event) => {
    if (
      typeof MAX_ANALYZER_LENGTH !== "undefined" &&
      event.target.files[0].size > MAX_ANALYZER_LENGTH
    )
      setAnalyzerForSendSizeError(true);
    else setAnalyzerForSendSizeError(false);
    await formik.setFieldValue(
      "nodejsPathFileAnalyzeForSend",
      event.target.files[0]
    );
    formik.setFieldTouched("nodejsPathFileAnalyzeForSend", true);
    const selectedFileAnalyzeForSend = event.target.files[0];
    setNodejsFileAnalyzeForSend(selectedFileAnalyzeForSend);
  };

  const handleUploadJsAnalyzerForSMSSend = async (event) => {
    if (
      typeof MAX_ANALYZER_LENGTH !== "undefined" &&
      event.target.files[0].size > MAX_ANALYZER_LENGTH
    )
      setAnalyzerForSMSSendSizeError(true);
    else setAnalyzerForSMSSendSizeError(false);

    await formik.setFieldValue("jsAnalyzerForSMSSend", event.target.files[0]);
    formik.setFieldTouched("jsAnalyzerForSMSSend", true);
    const selectedFileAnalyzeForSend = event.target.files[0];
    setJsAnalyzerFileForSMSSend(selectedFileAnalyzeForSend);
  };

  useEffect(() => {
    if (analyzerForSMSSendSizeError == true) {
      formik.setFieldTouched("jsAnalyzerForSMSSend", true);
    }
  }, [analyzerForSMSSendSizeError]);

  useEffect(() => {
    if (analyzerForSendSizeError === true) {
      formik.setFieldTouched("nodejsPathFileAnalyzeForSend", true);
    }
  }, [analyzerForSendSizeError]);

  const handleUploadNodejsAnalyzeForReceive = async (event) => {
    if (
      typeof MAX_ANALYZER_LENGTH !== "undefined" &&
      event.target.files[0].size > MAX_ANALYZER_LENGTH
    )
      setAnalyzerForReceiveSizeError(true);
    else setAnalyzerForReceiveSizeError(false);
    await formik.setFieldValue(
      "nodejsPathFileAnalyzeForReceive",
      event.target.files[0]
    );
    formik.setFieldTouched("nodejsPathFileAnalyzeForReceive", true);
    const selectedFileAnalyzeForReceive = event.target.files[0];
    setNodejsFileAnalyzeForReceive(selectedFileAnalyzeForReceive);
  };

  const handleUploadNodejsAnalyzeForSMSReceive = async (event) => {
    if (
      typeof MAX_ANALYZER_LENGTH !== "undefined" &&
      event.target.files[0].size > MAX_ANALYZER_LENGTH
    )
      setAnalyzerForSMSReceiveSizeError(true);
    else setAnalyzerForSMSReceiveSizeError(false);
    await formik.setFieldValue(
      "jsAnalyzerForSMSReceive",
      event.target.files[0]
    );
    formik.setFieldTouched("jsAnalyzerForSMSReceive", true);
    const selectedFileAnalyzeForReceive = event.target.files[0];
    setJsAnalyzerFileForSMSReceive(selectedFileAnalyzeForReceive);
  };

  useEffect(() => {
    if (analyzerForSMSReceiveSizeError === true) {
      formik.setFieldTouched("jsAnalyzerForSMSReceive", true);
    }
  }, [analyzerForSMSReceiveSizeError]);

  useEffect(() => {
    if (analyzerForReceiveSizeError === true) {
      formik.setFieldTouched("nodejsPathFileAnalyzeForReceive", true);
    }
  }, [analyzerForReceiveSizeError]);

  const [image, setImage] = useState<string | null>(null);
  const handleUploadImage = async (event) => {
    if (
      typeof MAX_IMAGE_LENGTH !== "undefined" &&
      event.target.files[0]?.size > MAX_IMAGE_LENGTH
    )
      setImageSizeError(true);
    else setImageSizeError(false);
    const selectedFile = event.target.files[0];
    setImageFile(selectedFile);
    await formik.setFieldValue("image", event.currentTarget.files[0]);
    formik.setFieldTouched("image", true);

    ///////////////////
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result;
        if (typeof result === "string") {
          setImage(result);
        }
      };
      reader.readAsDataURL(file);
    } else {
      setImage("");
    }
  };

  const handleUploadHelpFile = async (event) => {
    if (
      typeof MAX_HTML_PAGE_LENGTH !== "undefined" &&
      event.target.files[0]?.size > MAX_HTML_PAGE_LENGTH
    )
      setHtmlPageSizeError(true);
    else setHtmlPageSizeError(false);
    const selectedFile = event.target.files[0];
    setHelpFile(selectedFile);
    await formik.setFieldValue("helpFile", event.currentTarget.files[0]);
    formik.setFieldTouched("helpFile", true);
  };

  const handleUploadSettingFile = async (event) => {
    if (
      typeof MAX_SETTING_FILE_LENGTH !== "undefined" &&
      event.target.files[0]?.size > MAX_SETTING_FILE_LENGTH
    )
      setSettingFileSizeError(true);
    else setSettingFileSizeError(false);
    const selectedFile = event.target.files[0];
    setSettingFile(selectedFile);
    await formik.setFieldValue("settingFile", event.currentTarget.files[0]);
    formik.setFieldTouched("settingFile", true);
  };

  const handleNameChange = async (event) => {
    let value = event.target.value;
    if (value !== "" && value !== deviceName) {
      setDeviceName(event.target.value);
      let getDeviceByNameResult = await GetDeviceByName(
        value,
        userProducerCenterId
      );
      if (getDeviceByNameResult.data?.isSuccess == true) {
        if (getDeviceByNameResult.data.data.isExist == true) {
          setIsDeviceNameExist(true);
        } else {
          setIsDeviceNameExist(false);
        }
      }
    }
  };

  useEffect(() => {
    let name = formik.getFieldProps("name");
    if (name.value != "") {
      formik.setFieldTouched("name", true);
    }
  }, [isDeviceNameExist]);

  const customFilter = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  const changeDeviceCategoryHandler = (event) => {
    formik.setFieldValue("deviceCategoryId", event.value);
  };

  const registrationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, t("DEVICES.DEVICE_TITLE_MIN"))
      .max(300, t("DEVICES.DEVICE_TITLE_MAX"))
      .required(t("DEVICES.DEVICE_TITLE_REQUIRED"))
      .test("unique", t("DEVICES.DEVICE_NAME_EXISTS"), (value) => {
        if (isDeviceNameExist == true) return false;
        else return true;
      }),
    deviceCategoryId: Yup.string().required(t("DEVICES.DEVICE_CATEGORY_REQUIRED")),
    analyzeType: Yup.mixed().required(t("DEVICES.ANALYZE_TYPE_REQUIRED")),
    image: Yup.string()
      .required(t("DEVICES.IMAGE_REQUIRED"))
      .test(
        "maxSize",
        t("DEVICES.IMAGE_MAX_SIZE", { size: MAX_IMAGE_LENGTH }),
        (value) => {
          if (imageSizeError === true) return false;
          else return true;
        }
      ),
    helpFile: Yup.string()
      .required(t("DEVICES.HELP_FILE_REQUIRED"))
      .test(
        "maxSize",
        t("DEVICES.HELP_FILE_MAX_SIZE", { size: MAX_HTML_PAGE_LENGTH }),
        (value) => {
          if (htmlPageSizeError === true) return false;
          else return true;
        }
      ),
    settingFile: Yup.string()
      .nullable()
      .test(
        "maxSize",
        t("DEVICES.SETTINGS_FILE_MAX_SIZE", { size: MAX_SETTING_FILE_LENGTH }),
        (value) => {
          if (settingFileSizeError === true) return false;
          else return true;
        }
      ),
    nodejsPathFileAnalyzeForSend: Yup.string()
      .test(
        "nodeJsForSendEmpty",
        t("DEVICES.ANALYZER_FILE_SEND_REQUIRED"),
        (value) => {
          if (showFileAnalyze == true && value !== undefined && value !== null)
            return true;
          else if (showFileAnalyze == false) return true;
        }
      )
      .test(
        "maxSize",
        t("DEVICES.ANALYZER_FILE_MAX_SIZE", { size: MAX_ANALYZER_LENGTH }),
        (value) => {
          if (analyzerForSendSizeError == true && showFileAnalyze == true)
            return false;
          else return true;
        }
      ),
    nodejsPathFileAnalyzeForReceive: Yup.string()
      .test(
        "nodeJsForReceiveEmpty",
        t("DEVICES.ANALYZER_FILE_RECEIVE_REQUIRED"),
        (value) => {
          if (showFileAnalyze == true && value !== undefined && value !== null)
            return true;
          else if (showFileAnalyze == false) return true;
        }
      )
      .test(
        "maxSize",
        t("DEVICES.ANALYZER_FILE_MAX_SIZE", { size: MAX_ANALYZER_LENGTH }),
        (value) => {
          if (analyzerForReceiveSizeError == true && showFileAnalyze == true)
            return false;
          else return true;
        }
      ),
    tokenLink: Yup.string().test(
      "tokenEmpty",
      t("DEVICES.TOKEN_REQUIRED"),
      (value) => {
        if (showLinkAnalyze == true && value !== undefined && value !== null)
          return true;
        else if (showLinkAnalyze == false) return true;
      }
    ),
    link: Yup.string().test(
      "linkEmpty",
      t("DEVICES.LINK_REQUIRED"),
      (value) => {
        if (showLinkAnalyze == true && value !== undefined && value !== null)
          return true;
        else if (showLinkAnalyze == false) return true;
      }
    ),
    jsAnalyzerForSMSSend: Yup.string()
      .test(
        "nodeJsForSendSMSEmpty",
        t("DEVICES.ANALYZER_FILE_SMS_SEND_REQUIRED"),
        (value) => {
          if (
            sendSMSRequestTypeValue == "20" &&
            value !== undefined &&
            value !== null
          )
            return true;
          else if (
            sendSMSRequestTypeValue == "10" ||
            sendSMSRequestTypeValue == ""
          )
            return true;
        }
      )
      .test(
        "maxSize",
        t("DEVICES.ANALYZER_FILE_MAX_SIZE_MB", { size: parseInt(MAX_ANALYZER_LENGTH) / 1024 / 1024 }),
        (value) => {
          if (
            analyzerForSMSSendSizeError == true &&
            sendSMSRequestTypeValue == "20"
          )
            return false;
          else return true;
        }
      ),
    jsAnalyzerForSMSReceive: Yup.string()
      .test(
        "nodeJsForReceiveEmpty",
        t("DEVICES.ANALYZER_FILE_SMS_RECEIVE_REQUIRED"),
        (value) => {
          if (
            sendSMSRequestTypeValue == "20" &&
            value !== undefined &&
            value !== null
          )
            return true;
          else if (
            sendSMSRequestTypeValue == "10" ||
            sendSMSRequestTypeValue == ""
          )
            return true;
        }
      )
      .test(
        "maxSize",
        t("DEVICES.ANALYZER_FILE_MAX_SIZE_MB", { size: parseInt(MAX_ANALYZER_LENGTH) / 1024 / 1024 }),
        (value) => {
          if (
            analyzerForSMSReceiveSizeError == true &&
            sendSMSRequestTypeValue == "20"
          )
            return false;
          else return true;
        }
      ),
    smsAnalyzeType: Yup.mixed().test(
      "smsAnalyzeType",
      t("DEVICES.SMS_SEND_TYPE_REQUIRED"),
      (value) => {
        if (
          formik.getFieldProps("sendRequestBySMSGateway").value == true &&
          sendSMSRequestTypeValue != ""
        )
          return true;
        else if (formik.getFieldProps("sendRequestBySMSGateway").value == false)
          return true;
        else return false;
      }
    ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      try {
        const addNewDeviceResult = await AddNewDevice(
          values.name,
          values.deviceCategoryId,
          values.producerCenterId ?? "",
          nodejsFileAnalyzeForSend,
          nodejsFileAnalyzeForReceive,
          analyzeTypeValue,
          values.tokenLink,
          values.link,
          imageFile,
          helpFile,
          settingFile,
          values.sendRequestBySMSGateway,
          values.sendRequestDirectly,
          jsAnalyzerFileForSMSSend,
          jsAnalyzerFileForSMSReceive
        );

        if (addNewDeviceResult.data?.isSuccess == true) {
          setWarningMessage("");
          setShowWarningMessage(false);
          setErrorMessage("");
          setShowErrorMessage(false);
          setSubmitting(true);
          setLoading(false);
          closeModal.current?.click();
          closeAddDeviceModal();
          addDeviceSuccessfully();
          await showSwal();
        } else if (addNewDeviceResult.data?.isSuccess == false) {
          handleApiError(
            addNewDeviceResult,
            setWarningMessage,
            setShowWarningMessage,
            setErrorMessage,
            setShowErrorMessage
          );
          setSubmitting(false);
          setLoading(false);
          addDeviceFailed();
        } else {
          if (addNewDeviceResult?.response?.data == "Access Denied !") {
            setErrorMessage(t("COMMON.ACCESS_DENIED"));
            setShowErrorMessage(true);
          } else {
            setErrorMessage(t("DEVICES.DEVICE_SUBMIT_ERROR_WITH_DETAIL", { detail: addNewDeviceResult }));
            setShowErrorMessage(true);
          }
          setSubmitting(false);
          setLoading(false);
          addDeviceFailed();
        }
      } catch (error) {
        console.error(error);
        setStatus(t("AUTH.VERIFY.UNKNOWN_ERROR"));
        setSubmitting(false);
        setLoading(false);
      }
    },
  });

  const handlerShow = async () => {
    addDeviceFailed();
    changeAnalyzeTypeHandler(analyzeTypeOption[0])
    let getDeviceCategoryResult = await GetAllDeviceCategory();
    if (getDeviceCategoryResult.data?.isSuccess == true) {
      const deviceCategoriesList: DeviceCategories[] = [];
      getDeviceCategoryResult.data.data.forEach((element) => {
        deviceCategoriesList.push({
          icon: element.icon,
          label: element.name,
          value: element.id,
          name: element.name,
        });
      });
      setDeviceCategories(deviceCategoriesList);
    } else {
      handleFullApiError(
        getDeviceCategoryResult,
        setWarningMessage,
        setShowWarningMessage,
        setErrorMessage,
        setShowErrorMessage,
        t("DEVICES.DEVICE_CATEGORY_FETCH_ERROR")
      );
    }
  };
  return (
    <Modal
      id="kt_modal_add_device"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog mw-650px"
      show={showAddDeviceModal}
      onHide={closeAddDeviceModal}
      backdrop={true}
      onShow={handlerShow}
    >
      <form
        className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
        noValidate
        id="kt_login_signup_form"
        onSubmit={formik.handleSubmit}
        ref={formRef}
      >
        <div className="modal-content">
          <div className="modal-header pb-0 border-0 justify-content-end">
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={closeAddDeviceModal}
            >
              <KTIcon className="fs-1" iconName="cross" />
            </div>
          </div>

          <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15">
            <div className="text-center mb-13">
              <h1 className="mb-3">{t("DEVICES.DEVICE_ADD_NEW")}</h1>
              {formik.status && (
                <div className="mb-lg-15 alert alert-danger">
                  <div className="alert-text font-weight-bold">
                    {formik.status}
                  </div>
                </div>
              )}
              {/* begin alert message */}
              {showErrorMessage ? (
                <div className="alert alert-danger d-flex align-items-center p-5 mb-10">
                  <span className="svg-icon svg-icon-2hx svg-icon-danger me-3"></span>
                  <div className="d-flex flex-column">
                    <span>{errorMessage}</span>
                  </div>
                </div>
              ) : null}
              {showWarningMessage ? (
                <div className="alert alert-warning d-flex align-items-center p-5 mb-10">
                  <span className="svg-icon svg-icon-2hx svg-icon-warning me-3"></span>
                  <div className="d-flex flex-column">
                    <span>{warningMessage}</span>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="mh-400px scroll-y me-n7 pe-7">
              <div className="mb-10">
                <label className="form-label">{t("SERVICE.NAME")}</label>
                <input
                  type="text"
                  autoComplete="off"
                  placeholder={t("SERVICE.NAME")}
                  {...formik.getFieldProps("name")}
                  onBlur={handleNameChange}
                  className={clsx(
                    "form-control bg-transparent",
                    {
                      "is-invalid": formik.touched.name && formik.errors.name,
                    },
                    {
                      "is-valid": formik.touched.name && !formik.errors.name,
                    }
                  )}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                )}
              </div>
              <div className="mb-10">
                <label className="form-label">{t("DEVICES.DEVICE_CATEGORY")}</label>
                <Select
                  classNamePrefix="react-select"
                  {...formik.getFieldProps("deviceCategoryId")}
                  value={selectedDeviceCategoryOption}
                  name="deviceCategoryId"
                  onChange={changeDeviceCategoryHandler}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={false}
                  isRtl={false}
                  isSearchable={true}
                  className={clsx(
                    "react-select-styled basic-single",
                    {
                      "is-invalid":
                        formik.touched.deviceCategoryId &&
                        formik.errors.deviceCategoryId,
                    },
                    {
                      "is-valid":
                        formik.touched.deviceCategoryId &&
                        !formik.errors.deviceCategoryId,
                    }
                  )}
                  options={deviceCategories.map((item) => ({
                    ...item,
                    label: (
                      <div className="label">
                        <span>{item.label}</span>
                      </div>
                    ),
                  }))}
                  placeholder={t("DEVICES.DEVICE_CATEGORY_PLACEHOLDER")}
                  defaultValue={deviceCategories[0]}
                  filterOption={customFilter}
                />
                {formik.touched.deviceCategoryId &&
                  formik.errors.deviceCategoryId && (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.deviceCategoryId}
                      </div>
                    </div>
                  )}
              </div>
              <div className="mb-10">
                <label className="form-label">{t("DEVICES.ANALYZE_TYPE")}</label>
                <Select
                  classNamePrefix="react-select"
                  {...formik.getFieldProps("analyzeType")}
                  onChange={changeAnalyzeTypeHandler}
                  // value={analyzeTypeOption[0]}
                  options={analyzeTypeOption}
                  // defaultValue={analyzeTypeOption[0]}
                  placeholder={t("DEVICES.ANALYZE_TYPE_PLACEHOLDER")}
                  ref={selectRef}
                />

                {formik.touched.analyzeType && formik.errors.analyzeType && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.analyzeType}
                    </div>
                  </div>
                )}
              </div>
              {showFileAnalyze ? (
                <div>
                  <div className="mb-10">
                    <label className="form-label">{t("DEVICES.ANALYZER_FILE_SEND")}</label>
                    <input
                      type="file"
                      accept={acceptableFormatForAnalyzer}
                      id="nodejsPathFileAnalyzeForSend"
                      name="nodejsPathFileAnalyzeForSend"
                      onChange={handleUploadNodejsAnalyzeForSend}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.nodejsPathFileAnalyzeForSend &&
                            formik.errors.nodejsPathFileAnalyzeForSend,
                        },
                        {
                          "is-valid":
                            formik.touched.nodejsPathFileAnalyzeForSend &&
                            !formik.errors.nodejsPathFileAnalyzeForSend,
                        }
                      )}
                    />
                    {formik.touched.nodejsPathFileAnalyzeForSend &&
                      formik.errors.nodejsPathFileAnalyzeForSend && (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {formik.errors.nodejsPathFileAnalyzeForSend}
                          </div>
                        </div>
                      )}
                  </div>
                  <div className="mb-10">
                    <label className="form-label">
                      {t("DEVICES.ANALYZER_FILE_RECEIVE")}
                    </label>
                    <input
                      type="file"
                      accept={acceptableFormatForAnalyzer}
                      id="nodejsPathFileAnalyzeForReceive"
                      name="nodejsPathFileAnalyzeForReceive"
                      onChange={handleUploadNodejsAnalyzeForReceive}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.nodejsPathFileAnalyzeForReceive &&
                            formik.errors.nodejsPathFileAnalyzeForReceive,
                        },
                        {
                          "is-valid":
                            formik.touched.nodejsPathFileAnalyzeForReceive &&
                            !formik.errors.nodejsPathFileAnalyzeForReceive,
                        }
                      )}
                    />
                    {formik.touched.nodejsPathFileAnalyzeForReceive &&
                      formik.errors.nodejsPathFileAnalyzeForReceive && (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {formik.errors.nodejsPathFileAnalyzeForReceive}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              ) : showLinkAnalyze ? (
                <div>
                  <div className="mb-10">
                    <label className="form-label">{t("API_KEY.TOKEN")}</label>
                    <input
                      type="text"
                      {...formik.getFieldProps("tokenLink")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.tokenLink && formik.errors.tokenLink,
                        },
                        {
                          "is-valid":
                            formik.touched.tokenLink &&
                            !formik.errors.tokenLink,
                        }
                      )}
                    />
                    {formik.touched.tokenLink && formik.errors.tokenLink && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.tokenLink}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mb-10">
                    <label className="form-label">{t("DEVICES.LINK")}</label>
                    <input
                      type="text"
                      {...formik.getFieldProps("link")}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.link && formik.errors.link,
                        },
                        {
                          "is-valid":
                            formik.touched.link && !formik.errors.link,
                        }
                      )}
                    />
                    {formik.touched.link && formik.errors.link && (
                      <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                          {formik.errors.link}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
              <div className="mb-10">
                <label className="form-label">{t("DEVICES.HELP_FILE")}</label>
                <input
                  type="file"
                  id="helpFile"
                  name="helpFile"
                  onChange={handleUploadHelpFile}
                  accept={acceptableFormatForHelpFile}
                  className={clsx(
                    "form-control bg-transparent",
                    {
                      "is-invalid":
                        formik.touched.helpFile && formik.errors.helpFile,
                    },
                    {
                      "is-valid":
                        formik.touched.helpFile && !formik.errors.helpFile,
                    }
                  )}
                />
                {formik.touched.helpFile && formik.errors.helpFile && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.helpFile}
                    </div>
                  </div>
                )}
              </div>
              <div className="mb-10">
                <label className="form-label">{t("DEVICES.SETTINGS_FILE")}</label>
                <input
                  type="file"
                  id="settingFile"
                  name="settingFile"
                  onChange={handleUploadSettingFile}
                  accept={acceptableFormatForSettingFile}
                  className={clsx(
                    "form-control bg-transparent",
                    {
                      "is-invalid":
                        formik.touched.settingFile && formik.errors.settingFile,
                    },
                    {
                      "is-valid":
                        formik.touched.settingFile &&
                        !formik.errors.settingFile,
                    }
                  )}
                />
                {formik.touched.settingFile && formik.errors.settingFile && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.settingFile}
                    </div>
                  </div>
                )}
              </div>
              <div className="mb-10">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    type="checkbox"
                    {...formik.getFieldProps("sendRequestBySMSGateway")}
                    className="form-check-input"
                  />
                  <label className="form-label">
                    {t("DEVICES.SMS_COMMAND_SEND_ENABLED_HELP")}
                  </label>
                </div>
              </div>
              {formik.getFieldProps("sendRequestBySMSGateway").value ? (
                <>
                  <div className="mb-10">
                    <label className="form-label">
                      {t("DEVICES.SMS_SEND_TYPE")}
                    </label>
                    <Select
                      classNamePrefix="react-select"
                      {...formik.getFieldProps("smsAnalyzeType")}
                      onChange={changeSMSRequestTypeHandler}
                      options={sendSMSRequestType}
                      placeholder={t("DEVICES.SMS_SEND_TYPE_PLACEHOLDER")}
                    />
                    {formik.touched.smsAnalyzeType &&
                      formik.errors.smsAnalyzeType && (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {formik.errors.smsAnalyzeType}
                          </div>
                        </div>
                      )}
                  </div>
                </>
              ) : null}
              {sendSMSRequestTypeValue == "20" ? (
                <>
                  <div className="mb-10">
                    <label className="form-label">
                      {t("DEVICES.ANALYZER_FILE_SMS_SEND")}
                    </label>
                    <input
                      type="file"
                      accept={acceptableFormatForAnalyzer}
                      id="jsAnalyzerForSMSSend"
                      name="jsAnalyzerForSMSSend"
                      onChange={handleUploadJsAnalyzerForSMSSend}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.jsAnalyzerForSMSSend &&
                            formik.errors.jsAnalyzerForSMSSend,
                        },
                        {
                          "is-valid":
                            formik.touched.jsAnalyzerForSMSSend &&
                            !formik.errors.jsAnalyzerForSMSSend,
                        }
                      )}
                    />
                    {formik.touched.jsAnalyzerForSMSSend &&
                      formik.errors.jsAnalyzerForSMSSend && (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {formik.errors.jsAnalyzerForSMSSend}
                          </div>
                        </div>
                      )}
                  </div>
                  <div className="mb-10">
                    <label className="form-label">
                      {t("DEVICES.ANALYZER_FILE_SMS_RECEIVE")}
                    </label>
                    <input
                      type="file"
                      accept={acceptableFormatForAnalyzer}
                      id="jsAnalyzerForSMSReceive"
                      name="jsAnalyzerForSMSReceive"
                      onChange={handleUploadNodejsAnalyzeForSMSReceive}
                      className={clsx(
                        "form-control bg-transparent",
                        {
                          "is-invalid":
                            formik.touched.jsAnalyzerForSMSReceive &&
                            formik.errors.jsAnalyzerForSMSReceive,
                        },
                        {
                          "is-valid":
                            formik.touched.jsAnalyzerForSMSReceive &&
                            !formik.errors.jsAnalyzerForSMSReceive,
                        }
                      )}
                    />
                    {formik.touched.jsAnalyzerForSMSReceive &&
                      formik.errors.jsAnalyzerForSMSReceive && (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {formik.errors.jsAnalyzerForSMSReceive}
                          </div>
                        </div>
                      )}
                  </div>
                </>
              ) : null}
              <div className="mb-10">
                <label className="form-label">{t("DEVICES.IMAGE")}</label>
                <input
                  type="file"
                  //{...formik.getFieldProps('image')}
                  id="image"
                  name="image"
                  onChange={handleUploadImage}
                  accept={acceptableFormatForImage}
                  className={clsx(
                    "form-control bg-transparent",
                    {
                      "is-invalid": formik.touched.image && formik.errors.image,
                    },
                    {
                      "is-valid": formik.touched.image && !formik.errors.image,
                    }
                  )}
                />
                {formik.touched.image && formik.errors.image && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.image}</div>
                  </div>
                )}
                {image && (
                  <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                    <img src={`${image}`} alt="Metornic" />
                  </div>
                )}
              </div>
            </div>
            <button
              type="submit"
              className="btn btn-lg btn-main w-100 mb-5"
            //disabled={formik.isSubmitting || !formik.isValid || showErrorMessage == true || showWarningMessage == true}
            >
              {!loading && <span className="indicator-label">{t("COMMON.SUBMIT")}</span>}
              {loading && (
                <span className="indicator-progress display-block">
                  {t("AUTH.PLEASE_WAIT")}{" "}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              )}
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export { AddDevice };
